import { render, staticRenderFns } from "./household_allowance.vue?vue&type=template&id=fa3c1488&scoped=true"
import script from "./household_allowance.vue?vue&type=script&lang=js"
export * from "./household_allowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3c1488",
  null
  
)

export default component.exports